// extracted by css-extract-rspack-plugin
export default {"root":"JHomvF","expanded-grid":"yiPDxd","expandedGrid":"yiPDxd"};